import React, { ReactNode } from 'react';
import { ASSET_PREFIX } from 'utils/constants';

interface ITrustpilotLink {
  children: ReactNode;
  additionalClassName?: string;
}
const TrustpilotLink = ({ children, additionalClassName }: ITrustpilotLink) => (
  <a
    href="https://uk.trustpilot.com/review/daymade.co.uk"
    target="_blank"
    rel="noreferrer"
    className={additionalClassName}
  >
    {children}
  </a>
);

interface ICustomTrustPilotLogo {
  mobileLogoId?: string;
  desktopLogoId?: string;
  imagePath?: string;
}

const CustomTrustpilotLogo = ({
  mobileLogoId,
  desktopLogoId,
  imagePath = '/common/custom-trustpilot-logo-1.svg',
}: ICustomTrustPilotLogo) => {
  const altText = 'DAYMADE is rated Excellent on Trustpilot';
  return (
    <div className="customTrustpilotLogo">
      {mobileLogoId && desktopLogoId ? (
        <TrustpilotLink additionalClassName="mobileOnly">
          <img
            className="mobile-only"
            src={`${ASSET_PREFIX}/images/common/custom-trustpilot-logo-${mobileLogoId}.svg`}
            alt={altText}
          />
          <img
            className="desktop-only"
            src={`${ASSET_PREFIX}/images/common/custom-trustpilot-logo-${desktopLogoId}.svg`}
            alt={altText}
          />
        </TrustpilotLink>
      ) : (
        <TrustpilotLink>
          <img
            src={`${ASSET_PREFIX}/images${imagePath}`}
            alt={altText}
          />
        </TrustpilotLink>
      )}

      <style jsx>
        {`
          .customTrustpilotLogo img {
            width: 100%;
          }
        `}
      </style>
    </div>
  );
};

export default CustomTrustpilotLogo;
